import React from 'react';
import { Container } from '@/components/ui/container';
import { Stack } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

function Hero() {
  return (
    <section
      className={cn(
        "relative min-h-[20vh] flex items-center justify-center text-center",
        "bg-cover bg-center bg-no-repeat py-3"
      )}
      style={{
        backgroundImage: "url('https://cdn.builder.io/api/v1/image/assets/TEMP/70d4a9e6962ba0be1a978748ff16f4768ac3621f59809aed309f8041c5ca8d8c?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214')",
      }}
    >
      <div className="absolute inset-0 bg-primary/60 z-[1]" />
      <Container>
        <Stack spacing="sm" align="center" className="relative z-[2] max-w-3xl mx-auto">
          <Heading level="h1" className="text-2xl md:text-3xl font-bold text-white drop-shadow-lg">
            Company Admin Panel
          </Heading>
          <Text size="md" className="text-white/90 max-w-2xl">
            Monitor and manage company profiles with ease. Thoroughly review applications and assess key details. Take prompt, informed actions through a streamlined interface.
          </Text>
        </Stack>
      </Container>
    </section>
  );
}

export default Hero;